import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { ToastrService } from 'ngx-toastr';
import { AdminLocalStorageService } from './admin-local-storage.service';
import { environment } from '../../../environments/environment';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

@Injectable()
export class AuthLogoutService implements CanActivate {

    private poolData = {
      UserPoolId: 'eu-central-1_rGl2reFjn', // Your user pool id here
      ClientId: '6dm9vd98ep65dtk2r3fgaipp2a', // Your client id here
    };

    constructor(private auth: AuthenticationService
        , private router: Router
        , private route: ActivatedRoute
        , private ls: AdminLocalStorageService
        , private toastr: ToastrService) {}

        canActivate(): Promise<boolean> {
            return new Promise(resolve => {
                    this.ls.deleteToken();
                    // let userPool = new CognitoUserPool(this.poolData);
                    // let cognitoUser = userPool.getCurrentUser();  
                    // cognitoUser.signOut();
                    location.href = environment.aswlogout
                    resolve(true);
            });
        }
}
